'use client'
import { Box, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import axios from 'axios'
import { useDispatch } from "react-redux";
import LoadingSpinner from "./LoadingSpinner";
import NoItemsMessage from "./NoItemsMessage";
import EachProductCard from "./EachProductCard";
import { actions as builderActions } from '@/store/builderSlice';
import { accordionTitleConstants } from "./GetTrayComponentsForThreeDBuilder";
import DesignFavoriteButton from "../FavoriteButtons/DesignFavoriteButton";
interface ChildProps {
  handleMenuCloseDesignDetail: (isCloseMenu: boolean) => void;
  selectedDesignDetailsId: string;
  activeAccordion: any;
  handleMoreItemsClosed: (isCloseMenu: boolean) => void
  handleActiveAccordion: any;
  handleCloseProductDetails: (isCloseMenu: boolean) => void;
  handleSelectedProductDetailId: (itemId: string) => void;
}
export const apiStatusConstants = {
  initial: 'INITIAL',
  pending: 'PENDING',
  fulfilled: 'FULFILLED',
  rejected: 'REJECTED'
}
const DesignDetail: React.FC<ChildProps> = ({ handleMenuCloseDesignDetail, selectedDesignDetailsId, activeAccordion, handleMoreItemsClosed, handleActiveAccordion, handleCloseProductDetails, handleSelectedProductDetailId }) => {
  console.log('DesignDetail component start--------------------------------------------------')
  //state
  const [apiStatus, setApiStatus] = useState<string>(apiStatusConstants.initial)
  const [designDetails, setDesignDetails] = useState<any>()
  const dispatch = useDispatch()
  //effects
  useEffect(() => {
    //to fetch design details
    async function fetchData() {
      setApiStatus(apiStatusConstants.pending)
      try {
        const response = await axios.get(`https://d221a61rb87vel.cloudfront.net/v2/api/designs?designId=${selectedDesignDetailsId}`)
        if (response.data) {
          const designData = response.data.designs[0];
          if (designData?.isPersonalizable) {
            setDesignDetails(designData)
            dispatch(builderActions.addProductData({ products: designData.products.filter((eachProduct: any) => eachProduct.model3dUrl) }))
            setApiStatus(apiStatusConstants.fulfilled)
          } else {
            throw new Error('this design not support 3d')
          }
        } else {
          throw new Error('error while fetching data at DesignDetail component')
        }
      } catch (error) {
        console.log(error, 'error while fetching data at DesignDetail component')
        setApiStatus(apiStatusConstants.rejected)
      }

    }
    if (selectedDesignDetailsId) {
      fetchData()
    }
  }, [selectedDesignDetailsId])
  const getFulfilledView = (designDetails: any) => {
    return (
      <>
        <Box className="custom_scrollbar" sx={{ overflowY: 'auto', height: 'calc(100% - 50px)',position:'relative' }} component='div'>
          <img src={designDetails?.designImage} alt={designDetails?.designName} style={{ width: '100%', height: '40%', objectFit: 'cover', objectPosition: 'center' }} />
          <Box component='div' sx={{ position: 'absolute', left: '10px', top: '10px' }}>
            <DesignFavoriteButton eachDesign={{ itemId: designDetails?.designId, image: designDetails?.designImage, name: designDetails?.designName }} fontSize='20px' />
          </Box>
          <Typography sx={{ fontSize: '12px', padding: '10px 0 0 0' }}>{designDetails?.description}</Typography>
          <Typography sx={{ fontSize: '14px', padding: '10px 0' }}>Featured in this design:</Typography>
          <Grid container spacing={2}>
            {
              designDetails.products.length > 0 ? designDetails.products.map((eachProduct: any) => {
                return <Grid item xs={6} key={eachProduct.productId}>
                  <EachProductCard eachProduct={eachProduct} handleCloseProductDetails={handleCloseProductDetails} handleSelectedProductDetailId={handleSelectedProductDetailId} />
                </Grid>
              }) : <NoItemsMessage textToShow="No products available" />
            }
          </Grid>
        </Box>
      </>
    );
  }
  function getView(apiStatus: string) {
    switch (apiStatus) {
      case apiStatusConstants.pending:
        return <Box component='div' style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', width: '100%' }}><LoadingSpinner /></Box>
      case apiStatusConstants.fulfilled:
        return getFulfilledView(designDetails)
      case apiStatusConstants.rejected:
        return <Box component='div' style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', width: '100%' }}><NoItemsMessage textToShow="No Design Found" fontSize='16px' /></Box >
      default:
        return null
    }
  }
  //root return of jsx
  return (
    <>
      <Box component="div" sx={{ height: '50px', position: 'relative' }}>
        <KeyboardArrowLeftIcon onClick={() => {
          handleMenuCloseDesignDetail(true)
          if (activeAccordion.parentAccordion === accordionTitleConstants.designs) {
            handleMoreItemsClosed(false)
          }
        }} sx={{ color: '#52575C', fontSize: '34px', cursor: 'pointer', position: 'absolute', top: '0px', left: '-12px' }} />
        <HighlightOffIcon onClick={() => {
          handleMenuCloseDesignDetail(true)
          handleActiveAccordion({ parentAccordion: '', childAccordion: '' })
        }} sx={{ color: '#52575C', fontSize: '25px', cursor: 'pointer', position: 'absolute', top: '0px', right: '5px' }} />
        <Typography sx={{ fontSize: '16px', fontWeight: '700', display: 'flex', justifyContent: 'center' }}>{designDetails?.designName}</Typography>
        {/* <Typography sx={{fontSize: '10px', fontStyle: 'italic', display: 'flex', justifyContent: 'center', marginBottom: '10px', color: '#52575C'}}>In project</Typography> */}
      </Box>
      {getView(apiStatus)}
    </>
  )
};

export default DesignDetail;